import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { Dispatch } from "redux";
import { logAndDisplayErrorModal } from "./app-alert-util";

export const isFulfilled = <T extends Record<string, unknown>>(v: PromiseSettledResult<T>): v is PromiseFulfilledResult<T> => v.status === 'fulfilled';

export const isRejected = <T extends Record<string, unknown>>(v: PromiseSettledResult<T>): v is PromiseRejectedResult => v.status === 'rejected';

export const handleResponse = <T>(dispatch: Dispatch, response: PromiseSettledResult<GenericNetworkResponse<T>>, title: string, message: string): T => {
    if (isFulfilled(response)) {
        if (response.value.data) {
            return response.value.data;
        } else if (response.value.error) {
            logAndDisplayErrorModal(dispatch, response.value.error, title, message, null, response.value?.queryParameters, response.value?.body);   
        }
    } else if (isRejected(response)) {
        logAndDisplayErrorModal(dispatch, response.reason, title, message, null, response.reason?.queryParameters, response.reason?.body);
    }

    return null;
};